import React, { useState } from 'react';
import { useIntl } from 'umi';
import { Modal, Button, Form, TagSelect, Checkbox, notification, Input } from 'tea-component';
import useFormField from '../../hooks/useFormField';
import useConstants from '../../_config/constant';
import { saveSubscribeSetting } from '@/pages/dashboard/services/substribe';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { isMultipleEmails } from '@/pages/dashboard/utils/utils';

import './index.scss';

export interface SendModalProps {
  isVisible?: boolean;
  params?: any;
  close?: () => void;
  receiverList?: any[];
  isSelectOutEmail: boolean;
  menuId: boolean;
}

export default function TestModal(props: SendModalProps) {
  const {
    isVisible = false,
    params,
    close,
    receiverList,
    isSelectOutEmail,
    menuId
  } = props;
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(false);
  const { INITIAL_VALUES, WAYS, SETTING_FIELDS, FREQUENCY_KEY_MAP } = useConstants({ formatMessage });

  const {
    formValue,
    meta,
    input,
    hasErrors,
    setFormValue,
    handleSubmit,
  } = useFormField({
    formValue: INITIAL_VALUES,
    validate: ((fields: any) => {
      let receiverOutEmailMsg = undefined;
      if (isSelectOutEmail) {
        receiverOutEmailMsg = !isMultipleEmails(fields?.[SETTING_FIELDS.RECEIVERS]) ? formatMessage({ id: 'subscribe_setting_input_label_out_email_placeholder' }) : undefined;
      }
      return ({
        [SETTING_FIELDS.RECEIVERS]: receiverOutEmailMsg ? receiverOutEmailMsg : fields?.[SETTING_FIELDS.RECEIVERS]?.length < 1 ? formatMessage({ id: 'subscribe_setting_input_empty_receiver' }) : undefined,
        [SETTING_FIELDS.WAYS]: fields?.[SETTING_FIELDS.WAYS]?.length < 1 ? formatMessage({ id: 'subscribe_setting_input_empty_ways' }) : undefined,
      });
    })
  });

  const handleReceiversChange = (value) => {
    let result = value;
    if (isSelectOutEmail) {
      result = value;
    } else {
      result = value?.filter(item => receiverList?.some(receiver => receiver?.value === item));
    }
    setFormValue({
      ...formValue,
      [SETTING_FIELDS.RECEIVERS]: result
    });
  };

  const handleCancel = () => {
    setFormValue(INITIAL_VALUES);
    buriedBtnPoint({
      buttonId: '202501003',
      extInfo: 'subscribe test cancel',
      pageId: '202501'
    });
    close?.();
  };

  const handleConfirm = () => {
    if (hasErrors) return;
    const {
      receivers,
      ways,
      frequency
    } = formValue;
    const { type } = frequency;
    const frequencyKeys = FREQUENCY_KEY_MAP[type];
    const frequncyParams = {
      frequency_time: '',
      frequency_interval: ''
    };
    frequencyKeys?.forEach(key => {
      frequncyParams[key] = frequency[key];
    });
    const newParams = {
      ...(params ?? {}),
      // subscribe_id: '',
      // subscribe_title: 'test',
      frequency_type: 7,
      receiver_account: isSelectOutEmail ? receivers?.replaceAll(';', ',') : receivers?.join(','),
      receiver_user_ids: isSelectOutEmail ? '' : receivers?.join(','),
      send_type: ways?.join(',') || '',
      menu_id: menuId || '',
    };

    buriedBtnPoint({
      buttonId: '11050103',
      extInfo: JSON.stringify(newParams),
      pageId: '110501'
    });

    setLoading(true);
    saveSubscribeSetting(newParams)
      .then(() => {
        
        notification.success({
          description: (
            <span>
              {formatMessage({ id: 'subscribe_setting_save_success' })}
            </span>
          )
        });
      })
      .catch(() => {
        notification.error({
          description: (
            <span>
              {formatMessage({ id: 'subscribe_setting_save_fail' })}
            </span>
          )
        });
      })
      .finally(() => {
        setLoading(false);
        handleCancel();
      });
  };

  return (
    <div className='dbd-sendtestemail-popbox'>
      <Modal className='subscription-setting-send-dialog  dbd-suscribe-modal' visible={isVisible} caption={formatMessage({ id: 'subscribe_setting_test_title' })} onClose={handleCancel}>
        <Modal.Body>
          <form onSubmit={(value) => {
            handleSubmit(value);
          }}>
            <div className='dbd-sendtestemail-popbox-cont'>
              <Form>
                <Form.Item
                  className='form-item dbd-form-item-recipients'
                  label={formatMessage({ id: 'subscribe_setting_input_label_receiver' })}
                  required
                  status={meta?.[SETTING_FIELDS.RECEIVERS]?.status}
                  message={meta?.[SETTING_FIELDS.RECEIVERS]?.errorMessage}
                >
                  {
                    isSelectOutEmail ? <Input
                      className='dbd-subscribe-test-input'
                      {...input?.[SETTING_FIELDS.RECEIVERS]}
                      onChange={handleReceiversChange}
                      placeholder={formatMessage({ id: 'subscribe_setting_input_label_out_email_placeholder' })}
                    /> :
                      <TagSelect
                        placeholder={formatMessage({ id: 'subscribe_setting_input_placeholder_receiver' })}
                        options={receiverList}
                        {...input?.[SETTING_FIELDS.RECEIVERS]}
                        value={formValue?.[SETTING_FIELDS.RECEIVERS]}
                        onChange={handleReceiversChange}
                      />
                  }

                </Form.Item>
                <Form.Item
                  className='form-item'
                  label={formatMessage({ id: 'subscribe_setting_input_label_ways' })}
                  required
                  status={meta?.[SETTING_FIELDS.WAYS]?.status}
                  message={meta?.[SETTING_FIELDS.WAYS]?.errorMessage}
                >
                  <Checkbox.Group
                    {...input?.[SETTING_FIELDS.WAYS]}
                    value={formValue?.[SETTING_FIELDS.WAYS]}
                    onChange={(value) => (
                      setFormValue({
                        ...formValue,
                        [SETTING_FIELDS.WAYS]: value
                      })
                    )}
                  >
                    {
                      WAYS?.map(({ name, value }) => <Checkbox disabled={isSelectOutEmail && value === '2'} key={value} name={value}>{name}</Checkbox>)
                    }
                  </Checkbox.Group>
                </Form.Item>
              </Form>
            </div>

            <Form.Action>
              <Button
                loading={loading}
                type='primary'
                htmlType='submit'
                onClick={handleConfirm}
              >
                {formatMessage({ id: 'subscribe_setting_btn_confirm' })}
              </Button>
              <Button type='weak' onClick={handleCancel}>
                {formatMessage({ id: 'subscribe_setting_btn_cancel' })}
              </Button>
            </Form.Action>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
